import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { NotificationManager } from "react-notifications";
import { Tag } from "../../utils/GTMPageTag";
import { useLangContext } from "../../context/languageContext";

import {
  getCityByName,
  getPricingMailContractPlansByCityId,
} from "../../api/apiRequest";
import { Image } from "react-bootstrap";

import "./Detail.scss";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Pricing from "../../components/Pricing/Pricing";


const Detail = () => {  
  Tag("BusinessAddress")

  const { name } = useParams();
  const { t, i18n } = useTranslation(['common','pricing', name]);
  const { hostLanguage } = useLangContext();

  const [city, setCity] = useState();
  const getCity = async (city_id) => {
    try {
      let apiRes = await getCityByName(city_id);
      let responseData = await apiRes.json();
      if (responseData.length) {
        const dataArr = Object.values(responseData).filter(
          (obj) => typeof obj === "object"
        );
        setCity(dataArr[0]);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
    }
  };
  useEffect(() => {
    getCity(name);
  }, [hostLanguage ,name]);

  const [pricingInterval, setPricingInterval] = useState("month");
  const [planDetails, setPlanDetails] = useState();
  const getPlans = async (city_id, interval, language) => {
    try {
      let apiRes = await getPricingMailContractPlansByCityId(city_id, interval, language);
      let responseData = await apiRes.json();
      if (responseData.res) {
        setPlanDetails(responseData.data);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };
  
  useEffect(() => {
    if(city !== undefined){
      getPlans(city.id, pricingInterval, hostLanguage);
    }
  }, [city, pricingInterval, hostLanguage]);

  return (
    <>
      {(city === undefined ? 
        <></>
      :
        <>
          <Helmet>
            <title>{t(name+":meta.title")}</title>
            <meta name="language" content={hostLanguage} />
            <meta name="description" content={t(name+":meta.description")} />
            <meta name="keywords" content={t(name+":meta.keywords")} />
            <script type="application/ld+json">{JSON.stringify(t(name+":meta.schema", { returnObjects: true }))}</script>
          </Helmet>
          <Container id="businessAddressDetail" className="WebBody">
            <Row className="cta">
              <Col className="imageContainer" sm={12} md={6}>
                <Image src={t(name+":image")} alt={city.name} className="w-100 h-100 object-fit-cover"/>
              </Col>
              <Col className="textContainer" sm={12} md={6}>
                <h1>{t(name+":title")}</h1>
                <Link className={"btn primary"} to={"/bestellen/geschaeftsadresse/"+city.state.country_id+"/"+city.id}>{t(name+":button_1")}</Link>
                <Link className={"btn"} to={"/register"}>{t(name+":button_2")}</Link>
                <p className={"mt-4"}>{t(name+":description")}</p>
              </Col>
            </Row>
            <Row className="intervalSelect">
              <Col sm={12}>
                <Form.Check
                  id="Month"
                  type="radio"
                  name="pricing"
                  value="month"
                  checked={pricingInterval === "month"}
                  onChange={(e) => setPricingInterval(e.target.value)}
                />
                <Form.Label className="form-check-label" htmlFor="Month">
                  {t("pricing:monthly")}
                </Form.Label>
                <Form.Check
                  id="Year"
                  type="radio"
                  name="pricing"
                  value="year"
                  checked={pricingInterval === "year"}
                  onChange={(e) => setPricingInterval(e.target.value)}
                />
                <Form.Label className="form-check-label" htmlFor="Year"> 
                  {t("pricing:yearly")}
                </Form.Label>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <div className="sectionTitle">
                  <h2>CleverDomizil Postfach</h2>
                </div>
              </Col>
            </Row>
            <Pricing contract={planDetails} className="mb-4"/>
            {/* <Row className="priceList">
              <Col sm={12}>
                <table>
                  <tbody>
                    <tr>
                      <th className="headcol" style={{border:0}}>&nbsp;</th>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <th key={index}>
                              <h3>{item?.title}</h3> € {item?.price}
                              <br /> <p>{item?.description}</p>
                              <span>{item?.purpose}</span>
                            </th>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol" style={{border:0}}></td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              <Link
                                className="btn"
                                text={t("pricing:order_now")}
                                to={"/bestellen/geschaeftsadresse/"+item?.country_id + "/" + item.city_id + "/" +item?.id}
                              >{t("pricing:order_now")}</Link>
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_1")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.included_incoming_items === null
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : item?.included_incoming_items}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_2")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.envelope_scanning_front === null
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : item?.envelope_scanning_front}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_3")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.item_content_scanning === null
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : item?.item_content_scanning}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_4")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.free_storage_days_letters ===
                              null
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : item?.free_storage_days_letters}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_5")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.free_storage_days_parcels === null || item?.free_storage_days_parcels  === "0"
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : item?.free_storage_days_parcels}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_6")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.trashing_items === null || item?.trashing_items  === "0"
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : item?.trashing_items}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_7")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.dropbox_connection === null || item?.dropbox_connection  === "0"
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : item?.dropbox_connection}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_8")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.additional_incoming_items === null || item?.additional_incoming_items  === "0"
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : '€' + item?.additional_incoming_items}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_9")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              
                              {item?.envelope_scanning === null || item?.envelope_scanning  === "0"
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : '€' + item?.envelope_scanning}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_10")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              
                              {item?.item_content_scanning === null || item?.envelope_scanning  === "0"
                                ? <Image src={TickImg} className="TickImg" alt="TickImg"/>
                                : '€' +item?.item_content_scanning}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_11")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              €{" "}
                              {item?.direct_forwarding_charge_per_incident ==
                              null
                                ? "0.00"
                                : item?.direct_forwarding_charge_per_incident}{" "}
                                {t("pricing:addShipping")}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_12")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              €{" "}
                              {item?.collect_forwarding_charge_per_incident ==
                              null
                                ? "0.00"
                                : item?.collect_forwarding_charge_per_incident}{" "}
                                {t("pricing:addShipping")}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_13")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              €
                              {item?.storing_items_over_free_period_letters ===
                              null
                                ? "0.00"
                                : item?.storing_items_over_free_period_letters}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_14")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              €
                              {item?.storing_items_over_free_period_packages ===
                              null
                                ? "0.00"
                                : item?.storing_items_over_free_period_packages}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_15")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              €
                              {item?.scan_of_additional_pages === null
                                ? "0.00"
                                : item?.scan_of_additional_pages}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td className="headcol">{t("pricing:feature_16")}</td>
                      {planDetails?.contract_plan_details?.map(
                        (item, index) => {
                          return (
                            <td key={index}>
                              {item?.pages_included_in_content_scan ===
                              null
                                ? "X"
                                : item?.pages_included_in_content_scan}
                            </td>
                          );
                        }
                      )}
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row> */}
          </Container>
        </>
      )}
    </>
  );
};

export default Detail;
